module.exports = __webpack_public_path__ + "static/img/d-2.7f75565.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/layer3/d-2.png
// module id = C/sE
// module chunks = 1